import { render, staticRenderFns } from "./DokumenPasien.vue?vue&type=template&id=a6715c3c"
import script from "./DokumenPasien.vue?vue&type=script&lang=js"
export * from "./DokumenPasien.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6715c3c')) {
      api.createRecord('a6715c3c', component.options)
    } else {
      api.reload('a6715c3c', component.options)
    }
    module.hot.accept("./DokumenPasien.vue?vue&type=template&id=a6715c3c", function () {
      api.rerender('a6715c3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/retensi_dan_pemusnahan/DokumenPasien.vue"
export default component.exports